import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { getOperator, updateOperator } from '@/apis/operator'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { UpdateEmployeeRequest } from '@/types/apis/employees'
import { GetOperatorRequest } from '@/types/apis/operators/GetOperatorRequest'
import { GetOperatorResponse } from '@/types/apis/operators/GetOperatorResponse'
import { UpdateOperatorResponse } from '@/types/apis/operators/UpdateOperatorResponse'

export const useUpdateOperators = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateOperatorResponse>()
  const update = useCallback(
    async (request: UpdateEmployeeRequest) => {
      try {
        setLoading(true)
        const res = await updateOperator(request)
        setResponse(res)
        openNotification({ description: t('pages.operators.update.updateSuccessfully') })
        navigate(routes.operators.path)
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    updateOperator: update,
    response,
  }
}

export const useGetOperator = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetOperatorResponse>()

  const get = useCallback(async (request: GetOperatorRequest) => {
    try {
      setLoading(true)
      const res = await getOperator(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getOperator: get,
    response,
  }
}
